import { LinearEncoding, sRGBEncoding } from 'three';

export const textureEncodingValues = {
    LinearEncoding,
    sRGBEncoding,
};

export const textureEncodingNames: { [v: number]: TextureEncoding } = {};
Object.keys(textureEncodingValues).forEach((k: TextureEncoding) =>
{
    textureEncodingNames[textureEncodingValues[k]] = k;
});

export type TextureEncoding = keyof typeof textureEncodingValues;
